import { supabase } from '@/lib/supabase';
import { KpiTrackingEntry, ProjectDocument, Row } from '@/shared/types/api';
import { KpiUnit } from '@/shared/types/kpi';

export type BaseTrackingReport = Row<'kpi_tracking_reports'>;
type TrackingEntryPopulated = KpiTrackingEntry & { kpi: TrackingReportKpi };

type TrackingReportProject = { name: string; id: string };

type TrackingReportKpi = { name: string; unit: KpiUnit };

export type TrackingReportPopulated = Omit<
  BaseTrackingReport,
  'tracking_entries' | 'created_by' | 'project_id'
> & {
  tracking_entries: TrackingEntryPopulated[];
  creator_entity_name: string;
  documents: ProjectDocument[];
  project: TrackingReportProject;
};

export const getTrackingReports = async (
  projectId: number,
  monthsBack?: number,
  limit?: number,
  offset?: number,
): Promise<TrackingReportPopulated[]> => {
  const { data, error } = await supabase.rpc('get_tracking_reports', {
    p_project_id: projectId,
    p_months_back: monthsBack,
    p_limit: limit,
    p_offset: offset ?? 0,
  });

  if (error) throw error;

  if (!data || !Array.isArray(data)) return [];
  const populatedReports: TrackingReportPopulated[] = data.map(
    (report: any) => {
      return {
        ...report,
        creator_entity_name: report.creator_entity_name,
        tracking_entries: report.tracking_entries
          ? report.tracking_entries.map((entry: any) => ({
              ...entry,
              kpi: {
                name: entry.project_kpi.name,
                unit: KpiUnit.fromString(entry.project_kpi.unit),
              },
            }))
          : [],
        documents: report.documents || [],
        project: { name: report.project.name, id: report.project.id },
      };
    },
  );

  return populatedReports;
};
